import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';

class ClosedOrdersItems extends Component {

  handleEditButton = (orderID) => {
    // Edit the order
    console.log('EDIT ORDER');
  }

  // Take the props with all the open orders and display them in the table
  renderOrderItems() {
    var items = this.props.closedOrders;

    return items.map( (item, index) => {
      return(
        <tr key={item.id}>
          <th className="h4 align-middle p-1">{moment(item.order_time_start).format('DD/MM/YY hh:mm:ss a')}</th>
          <td className="h4 align-middle p-1">{item.server_id}</td>
          <td className="h4 align-middle p-1">{item.order_name}</td>
          <td className="h4 align-middle p-1">${item.grandtotal.toFixed(2)}</td>
          <td className="h4 text-xs-right">
            <button onClick={event => this.handleEditButton(item.id)} className="btn btn-primary btn-lg waves-effect waves-light">EDIT</button>
          </td>
        </tr>
      );
    });
  }

  render() {
    // If there are no open orders
    if (_.isEmpty(this.props.closedOrders)) {
      return (
        <span>There are no orders to show in this date range, try another time frame.</span>
      );
    }

    return(
      <table className="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th className="h4">Time</th>
            <th className="h4" data-priority="6">ID</th>
            <th className="h4" data-priority="6">Name</th>
            <th className="h4" data-priority="1">Total</th>
            <th className="h4 text-xs-right" data-priority="1"></th>
          </tr>
        </thead>
        <tbody>
          {this.renderOrderItems()}
        </tbody>
      </table>
    );
  }
}

export default ClosedOrdersItems;



// WEBPACK FOOTER //
// ./src/containers/closed_orders_items.js